<template>
  <div class="app">
    <v-card>
      <!-- <div>{{ dataset.datas.tblData }}</div> -->
      <!-- <v-btn small color="success" @click="check">Check</v-btn> -->
      <v-container fluid grid-list-lg>
        <div v-bind="text" class="font-weight-thin title">
          Ques: {{ text.question }}
        </div>
        <v-layout row>
          <v-flex xs12>
            <highcharts
              constructor-type="mapChart"
              :options="mapOptions"
              class="map"
              v-if="mapOptions.series[1].data.length"
            />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
  import mapDataIE from "@highcharts/map-collection/countries/bd/bd-all.topo.json";

  export default {
    props: ["dataset"],
    data: () => ({
      mapOptions: {
        chart: {
          map: mapDataIE,
          margin: 1,
        },

        title: {
          text: "",
          floating: false,
          style: {
            textOutline: "5px contrast",
          },
        },

        subtitle: {
          text: "",
          floating: true,
          y: 36,
          style: {
            textOutline: "5px contrast",
          },
        },

        mapNavigation: {
          enabled: true,
          buttonOptions: {
            alignTo: "spacingBox",
            verticalAlign: "bottom",
          },
        },

        mapView: {
          padding: [25, 0, 85, 0],
        },

        legend: {
          floating: true,
          backgroundColor: "#ffffffcc",
        },

        plotOptions: {
          mappoint: {
            keys: ["lat", "lon", "name"],
            marker: {
              lineWidth: 1,
              lineColor: "#000",
              symbol: "mapmarker",
              radius: 8,
            },
            dataLabels: {
              enabled: false,
            },
          },
        },

        tooltip: {
          headerFormat:
            '<span style="color:{point.color}">\u25CF</span> {point.key}<br/>',
          pointFormat: "{series.name}",
        },

        series: [
          // {
          //   allAreas: true,
          //   name: "Coastline",
          //   states: {
          //     inactive: {
          //       opacity: 0.2,
          //     },
          //   },
          //   dataLabels: {
          //     enabled: false,
          //   },
          //   enableMouseTracking: false,
          //   showInLegend: false,
          //   borderColor: "blue",
          //   opacity: 0.3,
          //   borderWidth: 10,
          // },
          {
            allAreas: true,
            name: "",
            states: {
              inactive: {
                opacity: 1,
              },
            },
            dataLabels: {
              enabled: false,
            },
            enableMouseTracking: false,
            showInLegend: false,
            borderColor: "rgba(0, 0, 0, 0.3)",
          },
          {
            name: "Location",
            color: "rgb(224, 81, 81)",
            // allAreas: true,
            // states: {
            //   inactive: {
            //     opacity: 1,
            //   },
            // },
            // dataLabels: {
            //   enabled: false,
            // },
            // enableMouseTracking: false,
            // showInLegend: false,
            // borderColor: "rgba(0, 0, 0, 0.3)",
            data: [],
            // [
            //   // [22.7013172, 90.3595877, "Major M A Jalil Rd, Barisal", 1],
            //   // [22.7016507, 90.3597122, "Oxford Mission Rd, Barisal", 2],
            //   // [22.7019933, 90.3591352, "Barishal", 3],
            //   // [23.8103, 90.4125, "Dhaka", 3],
            //   // [26.625846, 88.408879, "Banglabandha", 3],
            //   // [26.335377, 88.551697, "Panchagarh", 3],
            // ]
            type: "mappoint",
          },
        ],
      },
      text: {
        question: null,
      },
    }),
    watch: {
      dataset: function () {
        this.initialize();
      },
    },
    created() {
      this.initialize();
    },
    methods: {
      initialize() {
        // console.log(this.dataset.graphData.series);
        this.mapOptions.series[1].data = this.dataset.datas.tblData;
        this.text.question = this.dataset.queSet.question;
      },
    },
  };
</script>
<style scoped>
  .map {
    height: 500px;
    min-width: 310px;
    max-width: 800px;
    margin: 0 auto;
  }

  .loading {
    margin-top: 10em;
    text-align: center;
    color: gray;
  }
  ::v-deep .highcharts-credits {
    display: none;
  }
</style>
